
import Component, { mixins } from "vue-class-component"
import Produkte from "../custom/Produkte.vue"
import { Watch } from "vue-property-decorator"
import NichtGueltig from "../custom/NichtGueltig.vue"
import ShoppingLieferungLogic from "@/logic/bestellung_neu/shopping_lieferung_logic"
import ShoppingLieferung from "./ShoppingLieferung.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import Calculator from "../mixins/Calculator.vue"

@Component({
  name: "ShoppingProdukteLieferung",
  components: { Produkte, NichtGueltig, FilialeHeader },
})
export default class ShoppingProdukteLieferung extends mixins(Calculator) {
  logic?: ShoppingLieferungLogic = null

  created() {
    this.logic = (this.$parent as ShoppingLieferung).logic
  }

  @Watch("$parent.logic")
  watchLogic(value) {
    this.logic = value
  }
}
